import { initTdx } from '../../init/sdkTdx';
import { tdx_request, tdx_response } from "../../tdx_proto/bundle";
import { getConnectionPool } from '../../core/connectionPool';
import { hashString } from '../../utils/hash';

export class LedgerFile{
    file_name: string;
    start_time: number;
    end_time: number;
    file_size:number;
    log_hash: string;
    signed_hash: string;
    transaction_id: string;
    
    constructor(file_name: string, start_time: number, end_time: number, file_size:number, log_hash: string, signed_hash: string, transaction_id: string) {
        this.file_name = file_name;
        this.start_time = start_time;
        this.end_time = end_time;
        this.file_size = file_size;
        this.log_hash = log_hash;
        this.signed_hash = signed_hash;
        this.transaction_id = transaction_id;
    }
}
export class InclusionProof{
    transaction_id: string;
    proof:Uint8Array[];
    root_hash:Uint8Array;
    signed_root_hash:Uint8Array;
    leaf_hash:Uint8Array;
    leaf_index:number;
    leaf_count:number;
    constructor(transaction_id: string, proof:Uint8Array[], root_hash:Uint8Array, signed_root_hash:Uint8Array, leaf_hash:Uint8Array, leaf_index:number, leaf_count:number) {
        this.transaction_id = transaction_id;
        this.proof = proof;
        this.root_hash = root_hash;
        this.signed_root_hash = signed_root_hash;
        this.leaf_hash = leaf_hash;
        this.leaf_index = leaf_index;
        this.leaf_count = leaf_count;
    }
}
export class DownloadLogFile{
    data:Uint8Array;
    signed_log_hash:Uint8Array;
    certificate:Uint8Array;
    constructor(data:Uint8Array, signed_log_hash:Uint8Array, certificate:Uint8Array) {
        this.data = data;
        this.signed_log_hash = signed_log_hash;
        this.certificate = certificate;
    }
}
export async function download_log_file(file_name:string):Promise<DownloadLogFile>{
    // await sdkInit();
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();

    let times = 10;
    while (client.is_open() == false && times >= 0) {
        console.log('🔄 Waiting for WebSocket to open...');
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));

    }
    if (times < 0) {
        throw new Error("Connection Failed. Please try again.");
    }
        const req = tdx_request.Request.create({
        getAuditLog: tdx_request.GetAuditLog.create({
            pin: pin,
            data: data, // or provide actual bytes if needed
            name: file_name
        })
    });
     try {
        console.log('📨 Sending request for log files download', req);
        const res = await client.sendAndWait(req);
        console.log('📩 Received response for log files:', res);
        if (!res.getAuditLog || res.getAuditLog.status!==tdx_response.Status.SUCCESS){
            throw new Error("No data returned. Please check your query or try again later.");
        }
        let bytes_data= res.getAuditLog?.data || new Uint8Array();
        
        let download_log_file = new DownloadLogFile(
            bytes_data,
            res.getAuditLog?.signedHash,
            res.getAuditLog?.certificate,
        );
        client.close();
        return download_log_file;
    } catch (err) {
        throw Error('Error in request:'+ err);
    }

}
export async function get_inclusion_proof(file_name:string):Promise<InclusionProof>{
    // await sdkInit();
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();

    let times = 10;
    while (client.is_open() == false && times >= 0) {
        console.log('🔄 Waiting for WebSocket to open...');
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));

    }
    if (times < 0) {
        throw new Error("Connection Failed. Please try again.");
    }
        const req = tdx_request.Request.create({
        getInclusionProof: tdx_request.GetInclusionProof.create({
            pin: pin,
            data: data, // or provide actual bytes if needed
            logFileName: file_name
          
        })
    });
     try {
        console.log('📨 Sending request for log files download', req);
        const res = await client.sendAndWait(req);
        console.log('📩 Received response for log files:', res);
        client.close();
        if (!res.getInclusionProof || res.getInclusionProof.status!==tdx_response.Status.SUCCESS){
            throw new Error("No data returned. Please check your query or try again later.");
        }
        let proof = res.getInclusionProof;
        let inclusion_proof = new InclusionProof(
            proof.transactionId,
            proof.proof,
            proof.rootHash,
            proof.signedRootHash,
            proof.leafHash,
            typeof proof.leafIndex === "number" ? proof.leafIndex : proof.leafIndex.toNumber(),
            typeof proof.leafCount === "number" ? proof.leafCount : proof.leafCount.toNumber()
        );
        return inclusion_proof;
     
        
    } catch (err) {
        throw Error('Error in request:'+ err);
    }

}

export async function getLogFiles(start_time:number,end_time:number,pageSize:number=100):Promise<LedgerFile[]>{
    // await sdkInit();
    const pool = await getConnectionPool();
    const pin = await hashString(pool.getPin());
    const data = pool.getToken();
    const client = await initTdx();

    let times = 10;
    while (client.is_open() == false && times >= 0) {
        console.log('🔄 Waiting for WebSocket to open...');
        times -= 1;
        await new Promise(resolve => setTimeout(resolve, 1000));

    }
    if (times < 0) {
        throw new Error("Connection Failed. Please try again.");
    }

    // Example request for ListLogsFromQuery
    let page_token: Uint8Array = new Uint8Array();
    const log_file_metas: LedgerFile[] = [];
    while (true) {
        const req = tdx_request.Request.create({
        getLedgerRange: tdx_request.GetLedgerRange.create({
            startTime: start_time,
            endTime: end_time,
             pageTokenLogs: page_token, // or provide actual bytes if needed
            pin: pin,
            data: data, // or provide actual bytes if needed
            pageSize:pageSize // or any desired page size
        })
    });
     try {
        console.log('📨 Sending request for log files with page token:', req);
        const res = await client.sendAndWait(req);
        console.log('📩 Received response for log files:', res);
        if (!res.getLedgerRange || res.getLedgerRange.status!==tdx_response.Status.SUCCESS){
            throw new Error("No data returned. Please check your query or try again later.");
        }
        page_token = res.getLedgerRange?.pageTokenLogs ?? new Uint8Array();
        let log_files = res.getLedgerRange?.logFileMetas?.map(file => {
            return new LedgerFile(
                file.name,
                typeof file.startTime === "number" ? file.startTime : file.startTime.toNumber(),
                typeof file.endTime === "number" ? file.endTime : file.endTime.toNumber(),
                typeof file.size === "number" ? file.size : file.size.toNumber(),
                file.logHash,
                file.signedHash,
                file.transactionId
            );
        }) || [];
        log_file_metas.push(...log_files);
        if (page_token.length === 0) {
            console.log('✅ No more pages to fetch, breaking the loop.');
            break;
        }
       
    } catch (err) {
        throw Error('Error in request:'+ err);
    }


    }
    client.close();
    // console.log('📦 All JSON Rows:', all_json_rows);
    console.log(`Retrieved ${log_file_metas.length} log files from ledger.`);
    return log_file_metas;

}

